import { useState, useEffect, useRef, useContext } from 'react';
import './style.css';
import AlertMessage from '../../Alert';
import { CardContent } from '../../CardContent';
import { Title } from '../../Title';
import { Button,  Col, Row, Modal as ModalBoot } from 'react-bootstrap';
import api from '../../../services/api';
import { Tooltip, Grid } from '@mui/material';
import AttachEmailIcon from '@mui/icons-material/AttachEmail';
import { useNavigate } from 'react-router-dom';
import { DocumentoEmpresa } from '../DocumentoEmpresa';
import PaymentConfirmationModal from '../ModalAsoPagamento';
import { io } from 'socket.io-client';
interface AsoProntoProps {
    trabalhadorSelecionado: any | null;
    empresa: any | null;
    cnae: any | null;
}


export const AsoPronto: React.FC<AsoProntoProps> = ({ trabalhadorSelecionado, empresa, cnae }) => {

    // States para a função
    const [funcoes, setFuncoes] = useState([]);
    const [funcaoSelecionada, setFuncaoSelecionada]: any = useState();
    const [exames, setExames] = useState([]);
    const [riscos, setRiscos] = useState([]);
    const [openPdfModal, setOpenPdfModal] = useState(false);
    const [valorInicialTotal, setValorInicialTotal] = useState(0);
    const [paymentApproved, setPaymentApproved] = useState(false);
    const [descontoTotal, setDescontoTotal] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [qrCode, setQrCode] = useState('');
    const [alert, setAlert] = useState({ show: false, message: '', variant: 'success' });
    const [progressValue, setProgressValue] = useState(0);
    const [redirectCounter, setRedirectCounter] = useState(3);
    
    const handleClose = () => setShowModal(false)

    function handleOpenPdf() {
        setOpenPdfModal(true)
    }

    function handleClosePdf() {
        setOpenPdfModal(false)
    }
    const fetchExams = async () => {
        try {
            const response = await api.get(`buscar-dados-aso-pronto/${trabalhadorSelecionado.id}/${funcaoSelecionada.id}/${empresa.id}`)
            const responseData = response.data;
            setExames(responseData.examesTrabalhadorAtual);

            setRiscos(responseData.riscosFuncao);
            console.log(exames)
        } catch (error) {
            console.error(error);
        }
    }

    async function handlePayment() {
        try {
            let focusSet = false;

            // Verifica se algum dos campos obrigatórios está vazio
            if (!funcaoSelecionada) {
                if (!focusSet) {
                    const input = document.getElementById('funcaoSelecionada') as HTMLInputElement;
                    if (input) input.focus();
                    focusSet = true;
                }
            } 

            // Se algum campo estava vazio, exibe um alerta geral e sai da função
            if (!funcaoSelecionada ) {
                setAlert({
                    show: true,
                    message: "Por favor, preencha todos os campos obrigatórios.",
                    variant: "warning",
                });
                return;
            }

            // Se houver desconto total
            if (descontoTotal) {
                setPaymentApproved(true);
                handleOpenPdf();
            } else {
                if (exames.length > 0) {
                    
                    const paymentDetails = {
                        transaction_value: valorInicialTotal,
                        description: 'Pagamento de Reaproveitamento de ASO Pronto',
                        email: 'comercial@medicoatento.com.br', //TODO: Substituir pelo email para gerar pagamento
                        cpf: 'xxx.xxx.xxx-xx',
                    };
                    const response = await api.post('/pix/create', paymentDetails);
                    setQrCode(response.data.qr_code_base64);
                    setShowModal(true);
                }
            }
        } catch (error) {
            console.error('Erro ao criar pagamento PIX:', error);
        }
    };

    const transformarPreco = (valor: any) => {
        const valorDividido = valor / 100;
        return valorDividido.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    };

    const handleSelectFuncao = (funcao: any) => {
        setFuncaoSelecionada(funcao.ateBaseFuncao);
    };

    const handleSavePayment = async (data: any, userId: any) => {
        try {
            data.userId = userId;
            await api.post('salvar-pagamento-reaproveitamento', data);
        } catch (error) {
            console.log(error)
        }
    }

    useEffect(() => {
        const calcularValorInicial = () => {
            const somaValores = parseFloat(exames
                .reduce((total: number, exame: { valor_total: number }) => total + exame.valor_total / 100, 0)
                .toFixed(2));
            setValorInicialTotal(somaValores);
        };

        // Apenas calcula o valor inicial na primeira carga
        if (exames.length > 0 && valorInicialTotal === 0) {
            calcularValorInicial();
        }
    }, [exames]);
    
    useEffect(() => {
        const fetchFunctions = async () => {
            try {
                const response = await api.get(`buscar-funcoes-trabalhador/${trabalhadorSelecionado.id}`);
                const responseData = response.data;
                setFuncoes(responseData);
                
            } catch (error) {
                console.error(error);
            }
        };

        fetchFunctions();
    }, [trabalhadorSelecionado]);

    useEffect(() => {
        if (funcaoSelecionada) {
            fetchExams();   
        }
    }, [funcaoSelecionada])


    useEffect(() => {
        const socket = io(`${process.env.REACT_APP_SOCKET_URL}`, { transports: ['websocket', 'polling'] });

        socket.on('paymentStatusUpdated', (data: any) => {
            if (data.status === 'approved') {
                setPaymentApproved(true);
                handleSavePayment(data, empresa.id_usuario);
            }
        });

        return () => {
            socket.off('paymentStatusUpdated');
        };
    }, []);

    useEffect(() => {
        if (paymentApproved) {
            const progressTimer = setInterval(() => {
                setProgressValue((oldValue) => {
                    const newValue = oldValue + 1;
                    if (newValue === 100) {
                        clearInterval(progressTimer);
                        const redirectTimer = setInterval(() => {
                            setRedirectCounter((counter) => {
                                if (counter === 1) {
                                    clearInterval(redirectTimer);
                                    handleOpenPdf();
                                }
                                return counter - 1;
                            });
                        }, 1000);
                    }
                    return newValue;
                });
            }, 100);
        }
    }, [paymentApproved]);

    return (
        <>
            <div style={{
                display: 'flex',
                height: 'auto',
                padding: '10px',
                width: '100%', 
                boxSizing: 'border-box'
            }}>
                <CardContent>
                    <h5 style={{ color: '#0463C1', marginBottom: '20px' }}>
                        3º - Selecione a função que deseja:
                    </h5>
                    <Grid container spacing={2} style={{ display: 'flex', flexWrap: 'wrap', gap: '3px' }}>
                        {funcoes.map((funcao: any) => (
                            <Grid item key={funcao.ateBaseFuncao.id} style={{ display: 'flex', alignItems: 'center' }}>
                                <Button
                                    onClick={() => handleSelectFuncao(funcao)}
                                    style={{
                                        cursor: 'pointer',
                                        backgroundColor: funcaoSelecionada?.id === funcao.ateBaseFuncao.id ? '#E0F7FA' : '#fff',
                                        border: '2px solid #0463C1',
                                        color: '#0463C1',
                                        width: 'auto',
                                        height: 'auto',
                                        padding: '10px', 
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        textAlign: 'center',
                                        transition: '0.3s',
                                        boxSizing: 'border-box',
                                        fontWeight: '500',
                                    }}
                                    onMouseEnter={(e) => e.currentTarget.style.boxShadow = '0px 4px 10px rgba(0, 0, 0, 0.2)'}
                                    onMouseLeave={(e) => e.currentTarget.style.boxShadow = 'none'}
                                    variant="outlined"
                                >
                                    <div
                                        style={{
                                            whiteSpace: 'nowrap',
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            fontSize: '16px',
                                        }}
                                    >
                                        {funcao.ateBaseFuncao.nome}
                                    </div>
                                </Button>
                            </Grid>
                        ))}
                    </Grid>
                </CardContent>
            </div>

            {funcaoSelecionada && (
                <div style={{
                    display: 'flex',
                    height: 'auto',
                    padding: '10px'
                }}>
                    <CardContent>
                        <h5 style={{ color: '#0463C1', marginBottom: '20px' }}>
                            4º - Verifique as informações:
                        </h5>
                        <div>
                            <p>Função selecionada: {funcaoSelecionada?.nome}</p> 
                            <Title text="Cadastrar ASO Pronto" />
                        </div>
                        <Row>
                                <Col xs={12} md={12} xl={12} style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                                    <Row style={{ marginTop: '30px' }}>
                                        <h6 style={{ color: '#808080', textAlign: 'center' }}>Exames Incluídos</h6>
                                    </Row>
                                    <Row style={{ display: 'flex', justifyContent: 'center', overflowX: 'auto', width: '100%', borderRadius: '6px', border: '1px solid #0d6efd' }}>
                                        <table >
                                            <thead>
                                                <tr style={{ backgroundColor: '#0d6efd', color: 'white' }}>
                                                    <th style={{ fontSize: '15px', padding: '15px', textAlign: 'center', fontWeight: 'normal' }}>Ordem</th>
                                                    <th style={{ fontSize: '15px', padding: '15px', textAlign: 'center', fontWeight: 'normal' }}>Exame</th>
                                                    <th style={{ fontSize: '15px', padding: '15px', textAlign: 'center', fontWeight: 'normal' }}>Valor</th>
                                                   
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {exames.map((exame: any, index: number) => {
                                                    return (
                                                        <tr key={exame.id}>
                                                            <td style={{ fontSize: '15px', textAlign: 'center' }}>
                                                                <div>{index + 1}</div>
                                                            </td>
                                                            <td style={{ fontSize: '15px', textAlign: 'center', padding: '6px' }}>
                                                                {exame.ateBaseExames.nome}
                                                            </td>
                                                            <td style={{ fontSize: '15px', textAlign: 'center', padding: '6px' }}>
                                                                {transformarPreco(exame.valor_total)}
                                                            </td>
                                                            
                                                        </tr>
                                                    );
                                                })}
                                            </tbody>
                                        </table>
                                    </Row>
                                    <Row style={{ marginTop: '20px', textAlign: 'center', fontWeight: 'bold' }}>
                                        {exames.length > 0 && (
                                            <h5>Total: R$ {descontoTotal ? '0,00' : valorInicialTotal}</h5>
                                        )}
                                    </Row>
                                    <Row style={{ marginTop: '30px' }}>
                                        <h6 style={{ color: '#808080', textAlign: 'center' }}>Riscos da função</h6>
                                    </Row>
                                    <Row style={{ display: 'flex', justifyContent: 'center', overflowX: 'auto', width: '100%', borderRadius: '6px', border: '1px solid #0d6efd' }}>
                                        <table >
                                            <thead>
                                                <tr style={{ backgroundColor: '#0d6efd', color: 'white' }}>
                                                    <th style={{ fontSize: '15px', padding: '15px', textAlign: 'center', fontWeight: 'normal' }}>Ordem</th>
                                                    <th style={{ fontSize: '15px', padding: '15px', textAlign: 'center', fontWeight: 'normal' }}>Risco</th>
                                                    <th style={{ fontSize: '15px', padding: '15px', textAlign: 'center', fontWeight: 'normal' }}>Categoria</th>
                                                   
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {riscos.map((risco: any, index: number) => {
                                                    return (
                                                        <tr key={risco.id}>
                                                            <td style={{ fontSize: '15px', textAlign: 'center' }}>
                                                                <div>{index + 1}</div>
                                                            </td>
                                                            <td style={{ fontSize: '15px', textAlign: 'center', padding: '6px' }}>
                                                                {risco.nomeRisco}
                                                            </td>
                                                            <td style={{ fontSize: '15px', textAlign: 'center', padding: '6px' }}>
                                                                <Tooltip title={risco.nomeCategoria || ''}>
                                                                    <span>
                                                                        {risco.nomeCategoria ? risco.nomeCategoria : ''}
                                                                    </span>
                                                                </Tooltip>
                                                            </td>
                                                        </tr>
                                                    );
                                                })}
                                            </tbody>
                                        </table>
                                    </Row>
                                </Col>
                            </Row>
                            <Row style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: '50px' }}>
                                <button
                                    style={{ width: '8%', height: '30px', border: 'none', borderRadius: '5px', backgroundColor: '#4CAA1D', color: 'white' }}
                                    onClick={handlePayment}
                                >
                                    <AttachEmailIcon style={{ fontSize: '16px', marginRight: '7px' }} />
                                    Enviar
                                </button>
                            </Row>

                            {openPdfModal && (
                                <DocumentoEmpresa
                                    trabalhadorSelecionado={trabalhadorSelecionado}
                                    empresa={empresa}
                                    funcaoSelecionada={funcaoSelecionada}
                                    riscosIncluidos={riscos}
                                    examesCadastrados={exames}
                                    descontoTotal={descontoTotal}
                                    valorInicialTotal={valorInicialTotal}
                                    onClose={handleClosePdf}
                                    isAsoPronto={true}
                                    dadosCnae={cnae}
                                />
                            )}

                            <PaymentConfirmationModal 
                                show={showModal} 
                                handleClose={handleClose}
                                paymentApproved={paymentApproved}
                                progressValue={progressValue}
                                descontoTotal={descontoTotal}
                                valorInicialTotal={valorInicialTotal}
                                qrCode={qrCode}
                            />


                            <AlertMessage
                                show={alert.show}
                                message={alert.message}
                                variant={alert.variant}
                                onClose={() => setAlert({ ...alert, show: false })}
                            />
                    </CardContent>
                </div>
            )}

        </>
    )
}